/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardUsageDto } from '../../models/dashboard-usage-dto';

export interface AnalyticsTopDashboardsGet$Plain$Params {
  take?: number;
}

export function analyticsTopDashboardsGet$Plain(http: HttpClient, rootUrl: string, params?: AnalyticsTopDashboardsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardUsageDto>>> {
  const rb = new RequestBuilder(rootUrl, analyticsTopDashboardsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DashboardUsageDto>>;
    })
  );
}

analyticsTopDashboardsGet$Plain.PATH = '/analytics/top-dashboards';
